import React from "react";
import { FaLinkedinIn, FaGithub, FaPhone } from "react-icons/fa";
import { contactImg } from "../../assets/index";
import { GrMail } from "react-icons/gr";

const ContactLeft = () => {
  return (
    <div className="w-full lgl:w-[35%] h-full bg-gradient-to-r from-[#1e2024] to-[#23272b] p-4 lgl:p-8 rounded-lg shadow-shadowOne flex flex-col gap-8 justify-center">
      <img
        className="w-full h-64 object-cover rounded-lg mb-2"
        src={contactImg}
        alt="contactImg"
      />
      <div className="flex flex-col gap-4">
        <h3 className="text-3xl font-bold text-white">Priyank Gupta</h3>
        <p className="text-lg font-normal text-gray-400">
          MERN Stack Developer
        </p>
        <p className="text-base text-gray-400 tracking-wide">
          If you're looking to create a fully functional website that reflects
          your brand's unique identity, feel free to reach out to me. I'm
          dedicated to bringing your vision to life through top-notch web
          development skills and a commitment to your satisfaction.
        </p>
        <p className="text-base text-gray-400 flex items-center gap-2">
          Phone: <span className="text-lightText">+91 7300813764</span>
        </p>
        <p className="text-base text-gray-400 flex items-center gap-2">
          Email: <span className="text-lightText">priyank764fz7@gmail.com</span>
        </p>
      </div>
      <div className="flex flex-col gap-4">
        <h2 className="text-base uppercase font-titleFont mb-4">Find me in</h2>
        <div className="flex gap-4">
          <a href="https://github.com/priyankfz7" target="_blank">
            <span className="bannerIcon">
              <FaGithub />
            </span>
          </a>
          <a href="tel:+917300813764">
            <span className="bannerIcon">
              <FaPhone />
            </span>
          </a>
          <a
            href="https://www.linkedin.com/in/priyank-gupta-67a442249/"
            target="_blank"
          >
            <span className="bannerIcon">
              <FaLinkedinIn />
            </span>
          </a>
          <a href="mailto:priyank764fz7@gmail.com">
            <span className="bannerIcon">
              <GrMail />
            </span>
          </a>
        </div>
      </div>
    </div>
  );
};

export default ContactLeft;
